import React from 'react';

import { BlogCardContainer } from './styles'

type CardProps = {
    title: string;
    image:string;
    text: string;
    link:string;
}

const BlogCard = ({title, image, text, link}:CardProps) => {
  return (
      <BlogCardContainer background={image}>
         <div>
            <strong>{title}</strong>
            <p>{text}</p>
            <a target="_blank" href={link}>Saiba mais</a>
         </div>
      </BlogCardContainer>
  )
}

export default BlogCard;
